import React from 'react';
import { motion } from 'framer-motion';
import workExperienceData from '../data/UnrelatedWorkExperiance.json';

const UnrelatedWorkExperience = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="py-16"
    >
      <h2 className="section-heading">Unrelated Work Experience</h2>
      <div className="grid grid-cols-1 gap-6">
        {workExperienceData.experiences.map((experience, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}            className="bg-card rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow"
          >
            <div className="flex flex-col md:flex-row md:items-stretch gap-6 md:gap-10 h-full">
              {experience.logo && (
                <div className="flex-shrink-0 flex justify-center md:items-center">
                  <img
                    src={experience.logo}
                    alt={`${experience.company} logo`}
                    className="w-24 h-24 md:w-32 md:h-full object-contain rounded-lg bg-white p-3 shadow-sm"
                  />
                </div>
              )}
              <div className="flex-1 md:pl-4 flex flex-col justify-center text-center md:text-left">
                <h3 className="text-2xl font-semibold mb-2">{experience.title}</h3>
                <p className="text-lg text-primary mb-1">{experience.company}</p>
                <p className="text-muted-foreground mb-2">{experience.location}</p>
                <p className="text-muted-foreground">{experience.period}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default UnrelatedWorkExperience;
